import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteCategory } from '../Api'

export default generateApiAction({
  baseType: Types.CATEGORIES.DELETE,
  api: deleteCategory,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/categories/DeleteAction.js